export default class PlayerDetailedStatsFilters {
  public templateId: string = null;
  public playerId: string = null;
}
